import {asyncRouterMap, constantRouterMap} from '@/router'
import {loginByUsername, getUserInfo, adminLoginOut} from '@/api/login'
import {
  getToken,
  setToken,
  setRole,
  setName,
  setId,
  setMenu,
  getMenu,
  setPower,
  getRole,
  removePower, removeMenu, removeId, removeName, removeToken, removeRole
} from '@/utils/auth'
import zhLocale from '../../lang/zh'
import router from '../../router'

function setAsyncRouterMap(menu, asyncRouter) {
  const asyncRouterMap = asyncRouter.filter(item => {
    if (hasPermission(item, menu)) {
      if (item.children && item.children.length === 1) {
        return true
      }
      if (item.children && item.children.length) {
        item.children = setAsyncRouterMap(menu, item.children)
      }
      return true
    }
    return false
  })
  return asyncRouterMap
}

function hasPermission(item, menu) {
  for (let i = 0; i < menu.length; i++) {
    if (item.path === menu[i].url) {
      // item.meta.title = menu[i].menu_name
      zhLocale.route[item.meta.title] = menu[i].menu_name
      return true
    }
    if (item.meta.fid === menu[i].father_id) {
      return true
    }
  }
  return false
}

const user = {
  state: {
    routers: constantRouterMap,
    addRouters: [],

    id: '',
    token: getToken(),
    role: '',
    menus: [],
    powers: [],
    name: '',  // login_name
  },

  mutations: {
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    LoginByUserNameAndPassword({commit}, userInfo) {
      const username = userInfo.login_name.trim();
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo).then(response => {
          const data = response.data;
          if (data.status === "success") {
            //无订单权限不设置menu
            let isOrderManege = data.data.menus.filter(item=>{
              return item.url.indexOf("orderManege")>-1
            })
            if(!isOrderManege.length){
              resolve(response)
              return
            }

            setToken(data.data.token); //
            setName(data.data.login_name)
            setId(data.data.id)
            setMenu(data.data.menus)
            setPower(data.data.powers)
            setRole(data.data.role_name)

            commit('SET_TOKEN', data.data.token);
            commit('SET_NAME', data.data.login_name);
            commit('SET_ID', data.data.id);

            commit('SET_MENUS', data.data.menus);
            console.info("print request info ");
            // 刷新路由信息
            if (user.state.role.length === 0) {
              let asyncRouters = setAsyncRouterMap(getMenu(), asyncRouterMap)
              commit('SET_ROUTERS', asyncRouters)
              router.addRoutes(asyncRouters)
              commit('SET_ROLE', data.data.role_name); // commit的role值
            }
          }else{
            // this.$message.error(data.message)
            console.log('ss')
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    userPreme({commit}, data) {
      return new Promise(resolve => {
        commit('SET_ROLE', getRole())
        let asyncRouters = setAsyncRouterMap(getMenu(), asyncRouterMap)
        // 设置动态路由
        commit('SET_ROUTERS', asyncRouters)
        resolve()
      })
    },
    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        adminLoginOut().then(res => {
          if (res.data.status === 'success') {
            removePower()
            removeMenu()
            removeId()
            removeName()
            removeToken()
            removeRole()
          }
          // removeToken()

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js